import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Popover, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useFormatMessage } from '../../../../app/hooks';

export function Bread({ item, index, length }: { item: any; index: number; length: number }) {
  const fm = useFormatMessage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const { classes } = styles();

  const [anchorEl, setAnchorEl] = React.useState<HTMLAnchorElement | null>(null);
  const [expanded, setExpanded] = React.useState(false);
  const closeTimerRef = React.useRef<number | null>(null);

  const visibleCount = 6;
  const childrens = item.children?.filter((i: any) => i.active) || [];
  const displayedItems = expanded ? childrens : childrens.slice(0, visibleCount);

  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (item.children?.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setExpanded(false);
  };

  const startCloseDelay = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
    }
    closeTimerRef.current = window.setTimeout(handleClose, 200); // задержка 200мс
  };

  const cancelCloseDelay = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  return (
    <>
      <Link
        title={item.hoverTitle ?? ''}
        className={`${classes.link} ${item.isActive ? classes.activeLink : ''}`}
        to={`/${item.page}`}
        onMouseEnter={e => {
          cancelCloseDelay();
          handleOpen(e);
        }}
        onMouseLeave={startCloseDelay}
        onClick={e => {
          if (item.id.toString() === category) e.preventDefault();
          item.click && item.click();
          handleClose();
        }}
      >
        {item.translate ? fm(item.translate) : item.title}
      </Link>

      {length !== index + 1 && <span className='kt-subheader__breadcrumbs-separator'>- </span>}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className={classes.popever}
        disableScrollLock
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ pointerEvents: 'none' }}
        slotProps={{
          paper: {
            onMouseEnter: cancelCloseDelay,
            onMouseLeave: startCloseDelay,
            style: { pointerEvents: 'auto' }, // только контент ловит события
          },
        }}
      >
        <div className={classes.containerItems}>
          {displayedItems.map((i: any) => (
            <Typography
              component='p'
              key={i.id}
              className={classes.popoverName}
              sx={{ '&:hover': { color: '#205373' } }}
              style={{ color: i.id === item.id ? '#205373' : '#181c32b3' }}
              onClick={() => {
                if (i.id === item.id) return;
                if (i.id && item.onClickCategory) {
                  navigate(`/${item.page}`);
                  item.onClickCategory(i.id);
                }
                handleClose();
              }}
            >
              {i.name}
            </Typography>
          ))}
          {childrens.length > visibleCount && (
            <Typography
              component='p'
              className={classes.moreItems}
              onClick={() => setExpanded(!expanded)}
            >
              {fm(expanded ? 'HIDE' : 'SHOW.MORE')}
            </Typography>
          )}
        </div>
      </Popover>
    </>
  );
}

const styles = makeStyles()(theme => ({
  popever: {
    borderRadius: 8,
    marginTop: 20,
  },
  popoverName: {
    color: '#181c32b3',
    fontSize: 16,
    fontWeight: theme.typography.fontWeightRegular,
    cursor: 'pointer',
  },
  containerItems: {
    display: 'flex',
    flexDirection: 'column',
    padding: 19,
    gap: 10,
  },
  moreItems: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: '#22305e',
    cursor: 'pointer',
  },
  link: {
    padding: '0 0.35rem 0 0',
    fontSize: '17px !important',
    fontWeight: 'normal !important',
    color: '#181c3280',
    textDecoration: 'none',
    '&:hover': {
      color: '#006997',
    },
  },
  activeLink: {
    color: '#006997 !important',
  },
}));
